import { useMemo } from "react";
import { capitalize, FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { CategoryProfileRegionalSkew } from "@apiHooks/useCategoryProfileMenu";
import CategoryProfileDataColumns, { DataColumn } from "@pages/CategoryProfile/components/CategoryProfileDataColumns/CategoryProfileDataColumns";
import CategoryProfileSubtitle from "@pages/CategoryProfile/components/CategoryProfileSubtitle/CategoryProfileSubtitle";
import "./RegionalMenuSkews.styles.scss";

interface Props {
    skews: CategoryProfileRegionalSkew[];
    categoryName: string;
}

const REGIONAL_MENU_SKEWS_TOOLTIP =
    'particularly common terms, ingredients, and varieties in each region based on menuing; ' +
    'index values shown (vs. total U.S.)';

const RegionalMenuSkews: FCX<Props> = ({ skews, categoryName, className }) => {
    const columns: DataColumn[] = useMemo(
        () => skews.map(skew => ({
            label: skew.region ?? '',
            items: (skew.keywords ?? []).map(keyword => ({
                name: capitalize(keyword.wordName ?? ''),
                value: keyword.index ?? 0,
            }))
        })),
        [skews],
    );

    if (columns.length === 0) return null;

    return (
        <div
            className={cn("RegionalMenuSkews", className)}
            data-testid="blockCategoryProfileRegionalMenuSkews"
        >
            <div className="RegionalMenuSkews__header">
                <CategoryProfileSubtitle tooltipText={REGIONAL_MENU_SKEWS_TOOLTIP}>
                    {`Regional Menu Skews: ${categoryName}`}
                </CategoryProfileSubtitle>
            </div>

            <CategoryProfileDataColumns columns={columns} />
        </div>
    );
};

export default RegionalMenuSkews;
